import React, { useEffect, useRef, useState } from 'react';
import { Footer } from '../../Components/Footer';
import Webcam from 'react-webcam';
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import CropFreeIcon from '@mui/icons-material/CropFree';
import { useInsertSelfieMutation } from '../../generated/graphql';
import Loading from '../../Components/Loading/Loading';
import { b64toBlob } from '../../Components/Hooks/OCRhelper';

export const Selfie = (props: any) => {
	const {
		activeStep,
  	setActiveStep,
		HotelID,
		RegistrationID,
		BookingID
	} = props

	const webcamRef = useRef<Webcam | null>(null);

	const [image, setImage] = useState<string | null>(null);
	const [openSelfie, setOpenSelfie] = useState(false)
	const [confirmSelfie, setConfirmSelfie] = useState(false)

	const [
		InsertSelfie,
		{ loading: InsertSelfieLoading }
	] = useInsertSelfieMutation({
		fetchPolicy: 'no-cache',
		onCompleted: ({ InsertSelfie }) => {
			if (InsertSelfie) {
				setActiveStep(activeStep + 1);
			}
		}
	})

	const capture = () => {
		const video = webcamRef.current?.video as HTMLVideoElement;
		if (!video) return;
	
		const canvas = document.createElement("canvas");
	
		const width = video.videoWidth;
		const height = video.videoHeight;
	
		// match your preview aspect ratio (e.g. 3:4)
		const targetRatio = 3 / 4;
		let cropWidth = width;
		let cropHeight = width / targetRatio;
	
		if (cropHeight > height) {
			cropHeight = height;
			cropWidth = height * targetRatio;
		}
	
		const startX = (width - cropWidth) / 2;
		const startY = (height - cropHeight) / 2;
	
		canvas.width = cropWidth;
		canvas.height = cropHeight;
	
		const ctx = canvas.getContext("2d");
	
		ctx?.drawImage(
			video,
			startX,
			startY,
			cropWidth,
			cropHeight,
			0,
			0,
			cropWidth,
			cropHeight
		);
	
		const image = canvas.toDataURL("image/jpeg");
		setImage(image);
	};

	const onSubmit = () => {
		if (!image) return;

		const base64 = image.split(',')[1];
		const blob: any = b64toBlob(base64, 'image/jpeg', 512);
		blob['name'] = 'Selfie.jpg';
		blob['lastModified'] = Date.now();

		InsertSelfie({
			variables: {
				HotelID: HotelID,
				RegistrationID: RegistrationID,
				BookingID: BookingID,
				Selfie: blob,
			}
		})
	}

	useEffect(() => {
		if (image) {
			setOpenSelfie(true)
		}
	}, [image])

	return (
		<>
			{InsertSelfieLoading && <Loading />}

			<Card style={{ width: "100%", maxWidth: 400, alignSelf: 'center' }}>
				{confirmSelfie ? (
					<div style={{ display: "flex", justifyContent: "center", paddingBottom: 16 }}>
						<img src={image!} alt="selfie" />
					</div>
				) : (
					<>
						<CardContent>
							<Webcam
								ref={webcamRef}
								audio={false}
								screenshotFormat="image/jpeg"
								videoConstraints={{
									facingMode: "user"
								}}
								style={{
									width: "100%",
									height: "auto",
									aspectRatio: "3 / 4",
									objectFit: "cover",
									transform: "scaleX(-1)",
									display: "block"
								}}
							/>
						</CardContent>

						<div style={{ display: "flex", justifyContent: "center", paddingBottom: 16 }}>
							<Button
								type="submit"
								sx={{
									backgroundColor: '#ff9800',
									'&:hover': { backgroundColor: '#ff9800' },
									'&:active': { backgroundColor: '#ff9800' },
									color: '#ffffff',
								}}
								style={{
									minWidth: '126px',
									color: '#ffffff',
									backgroundColor: '#ff9800',
									padding: '6px 16px',
									borderRadius: '4px'
								}}
								variant="contained"
								onClick={capture}
							>
								<CropFreeIcon />
								&nbsp;SELFIE
							</Button>
						</div>
					</>
				)}
			</Card>

			<Footer
        primary={true}
        options={[
          {
            name: 'Next',
						disabled: confirmSelfie === false,
            onClick: () => {
							onSubmit()
              // setActiveStep(activeStep + 1);
            },
          },
        ]}
      />

			<Dialog 
				open={openSelfie}
				onClose={() => {
					setOpenSelfie(false)
				}}
			>
				<DialogTitle sx={{ fontSize: '1rem', fontWeight: 'bold', color: '#f5ab35', backgroundColor: '#fff5e7' }}>
					Confirm Selfie
				</DialogTitle>

				<DialogContent>
					<img src={image!} alt="selfie" />
				</DialogContent>

				<DialogActions>
					<Button
						onClick={() => {
							setImage(null)
							setOpenSelfie(false)
						}}
            sx={{
							fontWeight: 'bold',
    					color: '#ffffff',
              backgroundColor: '#f5ab35',
              '&:hover': { backgroundColor: '#f5ab35' },
              '&:active': { backgroundColor: '#f5ab35' },
            }}
					>
						Retake
					</Button>
					<Button
						onClick={() => {
							setConfirmSelfie(true)
							setOpenSelfie(false)
						}}
            sx={{
							fontWeight: 'bold',
    					color: '#ffffff',
              backgroundColor: '#f5ab35',
              '&:hover': { backgroundColor: '#f5ab35' },
              '&:active': { backgroundColor: '#f5ab35' },
            }}
					>
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}